import { NavLink, useLocation } from 'react-router';
import {
  LayoutDashboard,
  Users,
  CheckSquare,
  Building2,
  Download,
  FileText,
  Settings,
  Cpu,
  Shield,
  ShieldAlert,
  ShieldCheck,
  DollarSign,
  BarChart3,
  MessageSquare,
  FlaskConical,
  TestTube2,
  Globe,
  FilePenLine,
  type LucideIcon,
} from 'lucide-react';
import { useUIStore } from '../../stores/ui.store';

interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
}

const navItems: NavItem[] = [
  { path: '/', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/users', label: 'Users', icon: Users },
  { path: '/messages', label: 'Feedback', icon: MessageSquare },
  { path: '/approvals', label: 'Approvals', icon: CheckSquare },
  { path: '/edit-requests', label: 'Edit Requests', icon: FilePenLine },
  { path: '/companies', label: 'Companies', icon: Building2 },
  { path: '/companies/audit', label: 'Audit Logs', icon: FileText },
  { path: '/scrapers', label: 'Scrapers', icon: Cpu },
  { path: '/shield', label: 'Shield', icon: Shield },
  {
    path: '/admin/shield-admin-reviews',
    label: 'G11 Principal Reviews',
    icon: ShieldAlert,
  },
  {
    path: '/shield-runner',
    label: 'Report Runner',
    icon: ShieldCheck,
  },
  {
    path: '/shield-playbook',
    label: 'Playbook Runner',
    icon: ShieldCheck,
  },
  { path: '/fx', label: 'FX Management', icon: DollarSign },
  { path: '/re-matrix', label: 'RE Matrix', icon: BarChart3 },
  { path: '/features', label: 'Features', icon: FlaskConical },
  { path: '/experiments', label: 'A/B Tests', icon: TestTube2 },
  { path: '/translations', label: 'Translations', icon: Globe },
  { path: '/export', label: 'Export', icon: Download },
  { path: '/config', label: 'Config', icon: Settings },
];

function Sidebar() {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const location = useLocation();

  function isActive(path: string): boolean {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }

  return (
    <aside
      className={`sticky top-0 flex h-screen flex-col border-r border-gray-200 bg-white transition-all duration-200 ${
        sidebarOpen ? 'w-56' : 'w-16'
      }`}
    >
      <nav className="flex-1 overflow-y-auto px-2 py-4">
        <ul className="space-y-0.5">
          {navItems.map((item) => {
            const active = isActive(item.path);
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  className={`flex items-center gap-3 rounded-md py-1.5 text-sm transition-colors ${
                    active
                      ? 'bg-blue-50 font-medium text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50'
                  } ${!sidebarOpen ? 'justify-center px-3' : 'px-3'}`}
                  title={item.label}
                >
                  <Icon className="h-5 w-5 shrink-0" />
                  {sidebarOpen && <span className="truncate">{item.label}</span>}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;
